import LibraryService from '@/service/library'

export default {
  getListLibrary ({commit}, payload) {
    return new Promise((resolve, reject) => {
      LibraryService.getListLibrary()
        .then(res => {
          commit('getListLibrary', res.data.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
    })
  },
  destroy ({commit}, payload) {
    return new Promise((resolve, reject) => {
      LibraryService.destroy(payload.id).then(res => {
        commit('destroy', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getListTrash ({commit}, payload) {
    return new Promise((resolve, reject) => {
      LibraryService.getListTrash()
        .then(res => {
          commit('getListTrash', res.data.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
    })
  },

  restore ({commit}, payload) {
    return new Promise((resolve, reject) => {
      LibraryService.restore(payload.id)
        .then(res => {
          commit('restore', res.data.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
    })
  },

  destroyPermanently ({commit}, payload) {
    return new Promise((resolve, reject) => {
      LibraryService.destroyPermanently(payload.id)
        .then(res => {
          commit('destroyPermanently', res.data.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
    })
  },

  getLibrariesDoc ({commit}, payload) {
    return new Promise((resolve, reject) => {
      LibraryService.getLibraryDoc()
        .then(res => {
          console.log(res.data.data)
          commit('getLibraryDoc', res.data.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/library/actions.js